import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw = {
  name: 'client.learning',
  path: 'learning',
  redirect: { name: 'client.learning.plans' },
  meta: {
    roles: [Roles.Client],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
  children: [
    {
      name: 'client.learning.plans',
      path: 'plans',
      component: () => import('src/client/pages/learning/ClientPlans.vue'),
      redirect: { name: 'client.learning.plans.details' },
      meta: {
        roles: [Roles.Client],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
      children: [
        {
          name: 'client.learning.plans.details',
          path: '',
          component: () =>
            import('src/client/pages/learning/ClientPlanDetails.vue'),
          meta: {
            roles: [Roles.Client],
            supportedPlatforms: ['desktop', 'mobile', 'native'],
            excludeEnv: [],
          },
        },
      ],
    },
    {
      name: 'client.learning.focusArea',
      path: 'focusarea',
      component: () =>
        import('src/client/pages/learning/ClientFocusAreaReport.vue'),
      meta: {
        roles: [Roles.Client],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
    {
      name: 'client.learning.progress',
      path: 'progress',
      component: () =>
        import('src/client/pages/learning/ClientProgressReport.vue'),
      meta: {
        roles: [Roles.Client],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
    {
      name: 'client.learning.lessons',
      path: 'lessons/:lessonId',
      component: () => import('src/client/pages/learning/ClientLessons.vue'),
      meta: {
        roles: [Roles.Client],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
      children: [],
    },
  ],
}

export default routeRecord
